const en = {
  nav: {
    inicio: 'Home',
    servicios: 'Services',
    galeria: 'Gallery',
    contacto: 'Contact',
    cta: 'REQUEST A QUOTE',
    ctaMobile: 'GET A QUOTE',
  },

  hero: {
    title: 'Professional',
    titleHighlight: 'pest control',
    imgAlt: 'Professional Sanitization',
    subtitle: 'Safe solutions for businesses, residential areas, and specific spaces',
    subtitleBold: 'residential areas and specific spaces',
    techLine1: 'Thermal fogging technology',
    techLine2: '100% Biodegradable and free of toxic residues.',
    cta: 'SCHEDULE INSPECTION',
  },

  services: {
    badge: 'Technical Expertise',
    title: 'Our',
    titleHighlight: 'services',
    description: 'Protocols tailored to every need, from residential spaces to large industrial facilities in San Miguel de Allende, Irapuato, San Luis de la Paz, and Dolores Hidalgo CIN.',
    cards: [
      {
        title: 'Preventive Programs',
        desc: 'Customized plans to prevent infestations and ensure operational continuity. Constant monitoring with detailed reports.',
        tag: 'Preventive',
      },
      {
        title: 'Home Pest Control',
        desc: 'Safe and effective solutions for the home. Low-toxicity products suitable for families and pets.',
        tag: 'Residential',
      },
      {
        title: 'Bedrooms',
        desc: 'Specialized treatments for bedrooms and private areas. Elimination of bedbugs, mites, and nocturnal pests.',
        tag: 'Bedrooms',
      },
    ],
    customPlan: {
      title: 'Need a custom plan?',
      desc: 'We design specific strategies based on your facility\'s risk analysis.',
      cta: 'Request an Audit',
    },
    sectorsBadge: 'Where we work',
    sectorsTitle: 'Sectors we',
    sectorsTitleHighlight: 'serve',
    sectors: [
      {
        title: 'Dining Halls',
        desc: 'Rigorous pest control for industrial kitchens and food preparation areas.',
      },
      {
        title: 'Warehouses',
        desc: 'Continuous protection against pests in distribution and logistics centers.',
      },
      {
        title: 'Hotels',
        desc: 'Safe and pest-free environments for a flawless guest experience.',
      },
      {
        title: 'Bedrooms',
        desc: 'Specialized treatments for bedrooms and private areas.',
      },
    ],
    activeLabel: 'Active',
    trustBadgePrefix: 'Service available in',
    trustBadgeLocations: 'San Miguel de Allende, Irapuato, San Luis de la Paz, and Dolores Hidalgo CIN',
  },

  gallery: {
    badge: 'Our Work',
    title: 'Specialized Field Solutions',
    viewImage: 'View image',
    close: 'Close',
    images: [
      { title: 'School Pest Control', subtitle: 'Sanitization and pest control in educational institutions.' },
      { title: 'School Pest Control - Restrooms', subtitle: 'Specific treatments for sanitary areas in schools.' },
      { title: 'School Pest Control - Dining Area', subtitle: 'Guaranteed hygiene in food establishments.' },
      { title: 'Residential Pest Control', subtitle: 'Comprehensive solutions for homes and residences.' },
      { title: 'Residential Pest Control', subtitle: 'Sanitization and pest control for residential spaces.' },
      { title: 'Residential Pest Control', subtitle: 'Specialized treatments for patios and outdoor areas.' },
      { title: 'Residential Pest Control', subtitle: 'Specialized treatments for patios and outdoor areas.' },
      { title: 'Residential Pest Control', subtitle: 'Specialized treatments for patios and outdoor areas.' },
    ],
  },

  contact: {
    badge: 'Contact Us',
    title: 'Your home, free of',
    titleHighlight: 'pests.',
    subtitle: 'Tell us what\'s happening in your home or space and we\'ll provide a solution. Fast response, safe products for your family and pets.',
    callLabel: 'Call Us',
    emailLabel: 'Email Us',
    whatsappLabel: 'WhatsApp',
    whatsappValue: 'Chat with us',
    whatsappMessage: 'Hi, I need help with pests in my home',
    emergency: {
      title: 'Emergency at home?',
      desc: 'We respond the same day. No matter if it\'s cockroaches, mice, bedbugs, or any other pest.',
      cta: 'Message on WhatsApp →',
      message: 'I have a pest emergency',
    },
    form: {
      title: 'Request an inspection visit',
      subtitle: 'No cost · No commitment · Response within 24 hrs',
      name: 'Your Name',
      namePlaceholder: 'E.g. John Smith',
      phone: 'Phone',
      phonePlaceholder: '+1 555 ...',
      email: 'Email',
      emailPlaceholder: 'you@email.com',
      message: 'What\'s going on?',
      messagePlaceholder: 'Tell us what type of pest you have, in which area of your home, and since when...',
      submit: 'Request Inspection',
      sending: 'Sending...',
      success: '✓ Done! We\'ll contact you soon.',
      privacy: 'Your information is confidential and will never be shared.',
    },
    location: {
      badge: 'Where we are',
      mapTitle: 'SaniPlagas Location',
      branchesLabel: 'Our branches',
      mainBranch: 'Main office',
      newBranch: 'New branch',
      whatsappBranch: 'WhatsApp this branch',
      addressLabel: 'Address',
      scheduleLabel: 'Schedule',
      scheduleValue: 'Every day, 24 hours',
      emergencies247: '24/7 Emergencies',
      directions: 'Get Directions',
    },
  },

  // Dedicated landing page for the Irapuato branch (/irapuato), used as a Google Ads destination.
  irapuato: {
    metaTitle: 'Pest Control in Irapuato | SaniPlagas',
    metaDescription: 'Professional pest control in Irapuato. Free inspection, products safe for family and pets, 24/7 service. Call us at 462 373 7003.',
    badge: 'Irapuato Branch',
    title: 'Pest control in',
    titleHighlight: 'Irapuato',
    subtitle: 'New branch in Rincón de los Arcos. Free inspection, low-toxicity products, and same-day service.',
    ctaPrimary: 'BOOK A FREE INSPECTION',
    ctaCall: 'Call now',
    ctaWhatsapp: 'WhatsApp',
    trust: [
      { title: 'Free inspection', desc: 'We come, assess the problem, and quote with no commitment.' },
      { title: '24/7 service', desc: 'Emergencies handled the same day in Irapuato and nearby areas.' },
      { title: 'Safe for your family', desc: 'Biodegradable products, safe around children and pets.' },
      { title: 'Since 2012', desc: 'Over a decade solving pest problems in the Bajío region.' },
    ],
    servicesTitle: 'What we handle in Irapuato',
    servicesSubtitle: 'Homes, shops, dining halls, warehouses, and hotels. Treatment tailored to the problem.',
    formTitle: 'Book your inspection in Irapuato',
    formSubtitle: 'Leave us your details and we\'ll contact you the same day.',
    locationTitle: 'Our Irapuato branch',
    backToSite: 'View the full site',
  },

  footer: {
    bio: 'Professional pest control in San Miguel de Allende and Irapuato. Certified and ready 24/7.',
    navTitle: 'Navigation',
    servicios: 'Services',
    galeria: 'Gallery',
    contacto: 'Contact',
    emergencyTitle: 'Emergencies',
    support247: '24/7 Support · Immediate response',
    privacyTerms: 'Privacy & Terms',
    understood: 'Understood',
    legalText: `PRIVACY NOTICE

saniplagasSA DE CV, commercially known as saniplagas, with address at Alfil 22, INFONAVIT Malanquin, 37755 San Miguel de Allende, Gto., Mexico, is responsible for the use and protection of your personal data.

PRIMARY PURPOSES
The personal data we collect from you will be used for the following purposes that are necessary for the service you request:

• Response to contact form messages

SECONDARY PURPOSES
Additionally, we will use your personal information for the following secondary purposes that are not necessary for the requested service, but allow us to provide better service:

• Marketing or advertising

PERSONAL DATA COLLECTED
For the purposes stated in this privacy notice, we may collect your identification and contact data.

ARCO RIGHTS
You have the right to know what personal data we have about you, what we use it for, and the conditions of use (Access). You also have the right to request the correction of your personal information if it is outdated, inaccurate, or incomplete (Rectification); to have it deleted from our records or databases when you consider it is not being used properly (Cancellation); and to oppose the use of your personal data for specific purposes (Opposition). These rights are known as ARCO rights.

To exercise any of the ARCO rights, you must submit the respective request through contacto@saniplagas.mx. Your request will be answered within a maximum of 5 business days.

DATA COLLECTED BY THE WEBSITE
Our website automatically collects the following data:

• Web pages visited by a user
• Advertising reviewed by a user

CONTACT
For more information about this privacy notice, you can contact us at:

Email: contacto@saniplagas.mx
Website: https://saniplagas.mx

Last updated: 2/20/2026


TERMS OF USE
The use of this site implies acceptance of these terms. The content is the property of SaniPlagas and may not be reproduced without authorization. Services are subject to availability in the San Miguel de Allende area and metropolitan zone. SaniPlagas reserves the right to modify prices and conditions without prior notice.

For more information contact: contacto@saniplagas.mx`,
  },

  whatsapp: {
    tooltip: 'Need help?',
    tooltipBold: 'Message us!',
    defaultMessage: 'Hi, I would like to request a quote for pest control service',
  },

  a11y: {
    title: 'Accessibility',
    fontSize: 'Text size',
    sizeNormal: 'Normal',
    sizeLarge: 'Large',
    sizeXL: 'Extra large',
    highContrast: 'High contrast',
    grayscale: 'Grayscale',
    underlineLinks: 'Underline links',
    readingGuide: 'Reading guide',
    reset: 'Reset',
    close: 'Close accessibility panel',
    open: 'Open accessibility options',
    skipToContent: 'Skip to main content',
  },
};

export default en;

